import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../Icon';
import { signOut } from '../../Actions/Login.action';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const MyPagesMobileMenu = ({ navigation }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );

  return (
    <div className="relative mb-4 h-14 overflow-hidden rounded border border-solid border-gray-300 lg:hidden">
      <label
        htmlFor="menu"
        className="pointer-events-none absolute flex h-full w-full items-center justify-between px-4 capitalize"
      >
        <div className="flex flex-col justify-center">
          <span className="color-gray-600 text-md">
            {userInfo?.currentOrganizationName ??
              translate('mypage.site.title')}
          </span>
          <h5 className="name">
            {userInfo?.firstName} {userInfo?.lastName}
          </h5>
        </div>
        <Icon name="caret-down" className="h-6 w-6 text-gray-900" />
      </label>
      <select
        id="menu"
        defaultValue={pathname}
        onChange={(e) => {
          e.target.value == 'log-out'
            ? signOut()
            : navigate(e.target.value);
        }}
        className="mb-4 h-full w-full border-0 text-transparent focus:outline-none"
      >
        {navigation.map((option) => (
          <option
            value={option.url}
            key={option.url + 'mobile'}
            className="text-md text-gray-900"
          >
            {option.name}
          </option>
        ))}
        <option value="log-out" className="text-md text-gray-900">
          {translate('general.sign-out')}
        </option>
      </select>
    </div>
  );
};

export default MyPagesMobileMenu;
